export const MAX_BOND_SCREENER_VIEWS = 20;

export const BOND_SCREENER_VIEWS_LIMIT_MESSAGE = `You are out of ${ MAX_BOND_SCREENER_VIEWS } views limit`;

export const RESTRICTED_ACCESS_MESSAGE = 'Upgrade your plan on the Pricing page to access';

export const GUEST_ACCESS_MESSAGE = 'Log in or sign up to access';
